var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 4.16927H2.5026M2.5026 4.16927H15.8359M2.5026 4.16927V15.8359C2.5026 16.278 2.6782 16.7019 2.99076 17.0144C3.30332 17.327 3.72724 17.5026 4.16927 17.5026H12.5026C12.9446 17.5026 13.3686 17.327 13.6811 17.0144C13.9937 16.7019 14.1693 16.278 14.1693 15.8359V4.16927H2.5026ZM5.0026 4.16927V2.5026C5.0026 2.06058 5.1782 1.63665 5.49076 1.32409C5.80332 1.01153 6.22724 0.835938 6.66927 0.835938H10.0026C10.4446 0.835938 10.8686 1.01153 11.1811 1.32409C11.4937 1.63665 11.6693 2.06058 11.6693 2.5026V4.16927M6.66927 8.33594V13.3359M10.0026 8.33594V13.3359",
    stroke: "#E00000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.ea30cf0a7a56c884c9071d65afd59166.svg";
export { ForwardRef as ReactComponent };